import { useRef } from "react";
import { useRouter } from "../hooks";
import { useFocusEffect } from "../useFocusEffect";
var redirectsInFlight = /* @__PURE__ */ new Set();
function Redirect(param) {
  var { href } = param;
  var router = useRouter();
  var hasRedirected = useRef(false);
  useFocusEffect(function() {
    if (hasRedirected.current) return;
    var key = typeof href === "string" ? href : JSON.stringify(href);
    if (redirectsInFlight.has(key)) return;
    hasRedirected.current = true;
    redirectsInFlight.add(key);
    Promise.resolve(router.replace(href)).catch(function(error) {
      hasRedirected.current = false;
      console.error(error);
    }).finally(function() {
      redirectsInFlight.delete(key);
    });
  }, [
    href
  ]);
  return null;
}
export {
  Redirect
};
//# sourceMappingURL=Redirect.js.map
